import { DeleteOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export const Container = styled.div``;

export const Div = styled.div``;

export const NameStrong = styled.strong``;

export const FontSize = styled.div`
  font-weight: 500;
  font-size: 18px;
`;

export const DeleteItemIcon = styled(DeleteOutlined)`
  color: ${(props) => props.theme.colors.btnDanger};
  font-size: 25px;
  height: 50px;
  margin-left: 40%;
  margin-bottom: 15%;
  width: 100%;
  block-size: 3px;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  justify-self: right;
  width: 80%;
  color: #096dd9;
`;

export const BadgeAdd = styled.strong`
  margin-left: 2%;
  display: inline-block;
  position: absolute;
  top: -10px;
`;

export const BadgeCar = styled.strong`
  display: inline-block;
  position: absolute;
  top: -12px;
`;

export const Spacement = styled.div`
  @media (max-width: 991.98px) {
    .ant-btn > span + span {
      display: none;
    }
  }
`;

export const Footer = styled.strong`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #595959;
`;

export const Value = styled.strong`
  font-style: normal;
  font-size: 16px;
  color: #595959;
  margin-left: 60%;
`;
